import {
  GET_ADMIN_BOOKING_DETAILS,
  GET_ADMIN_BOOKING_DETAILS_SUCCESS,
  GET_ADMIN_BOOKING_DETAILS_ERROR,
  GET_ADMIN_BOOKING_DETAILS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAdminBookingDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_BOOKING_DETAILS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ADMIN_BOOKING_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ADMIN_BOOKING_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ADMIN_BOOKING_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAdminBookingDetails;
